module.exports = __webpack_public_path__ + "img/8.152e8920.png";